<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead 
      :title="'Hotel Groups'"
      :buttons='[{
        title:"Add Hotel Group",
        icon:"fa fa-plus",
        emit:"add"
      }]'
      @add="addShow=true"></cardHead>
      <dataTable :name="'HotelGroups'" ref="agGrid" :data="data" @update="updateShow={...$event}" @remove="remove"></dataTable>
      <upsert v-if="addShow || updateShow!=null" :setModel="updateShow" @add="$refs.agGrid.addRow([$event])" @update="$refs.agGrid.changeRow('Id',$event);" @close="addShow=false;updateShow=null"></upsert>
    </div>
  </div>
</template>

<script>
  import upsert from "./upsert";
  export default {
    name: 'HotelGroups',
    components:{upsert},
    data(){
      return { 
        data:null,
        addShow:false,
        updateShow:null
      }
    },
    created(){
      this.$appAxiosAdmin.get(`HotelGroups`).then(response => {
        this.data=response.data;
      });
    },
    methods:{
      remove(item){
          this.$swal({
              icon:"question",
              title:"Warning",
              text:"Are you sure you want to delete the hotel group named "+item.Name+"?",
              showCancelButton:true,
              confirmButtonText:"Yes",
              cancelButtonText:"No"
          }).then(question=>{
              if(question.isConfirmed){
                  this.$appAxiosAdmin.delete(`HotelGroups/`+item.Id).then(() => {
                      this.$refs.agGrid.removeRow([item]);
                      this.$swal({
                          icon:"success",
                          title:"Success",
                          text:">Hotel group deleted successfully.",
                          timer: 2000,
                          confirmButtonText:"Okey"
                      });
                  }).catch(err=>{
                    this.$isError(err);
                  });
              }
          });
      }
    }
  }
</script>
